<template>
  <div class="telemetry-gear-pos-parts">
    <p class="telemetry-gear-pos-parts__label"><span>Gear</span></p>
    <p class="telemetry-gear-pos-parts__data">{{ value }}</p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * レース動画再生画面 テレメトリー ギアポジション値パーツのコンポーネント
 */
export default defineComponent({
  name: 'TelemetryGearPosParts',
  components: {},
  props: {
    /**
     * バリュー値
     */
    value: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.telemetry-gear-pos-parts {
  position: absolute;
  left: calc(#{min(4.2667vw, 1.333em)} + 1.6667em);
  top: calc(#{min(4.2667vw, 1.333em)} + 1.8em);
  width: 25.25em;
  text-align: center;

  &__label {
    font-size: 0.91667em;
    color: $white;
    letter-spacing: 0.04em;
    padding-left: 0.04em;
    opacity: 0.7;

    span {
      font-size: max(1em, 8px);
    }
  }

  &__data {
    font-size: 2em;
    color: $white;
    font-weight: 300;
    line-height: 1;
    font-family: $fontTelemetrySpeedGear;
  }
}
</style>

<style lang="scss">
.race-telemetry-section {
  &--landscape-primary,
  &--landscape-secondary {
    .telemetry-gear-pos-parts {
      top: 2em;

      &__data {
        line-height: 1.2;
      }
    }
  }
}
</style>
